import React from 'react'
import { useGetMobilNorthChinaTripPoint } from '../../api/point'
import { PointDetails } from '../shared/PointDetails'

export const MobilNorthChinaTripPoint = () => {
  return (
    <PointDetails
      title='Mobil North China Trip Point'
      useGetPoint={useGetMobilNorthChinaTripPoint}
      backLink={'mobil-north-china-trip-point'}
      accountSummary={[]}
      purchaseHistory={[{ label: 'Liter', id: 'liter' }]}
    />
  )
}
